import React, { Component } from "react";
import styles from "./CategoriesSettings.local.scss";
import classnames from "classnames";
import Select from "react-select";
import _ from "i18n";
import { Switch } from "antd";

class LabelsForm extends Component {
  render() {
    const {
      labels,
      superCategoriesOptions,
      analysisPlanOptions,
      valuationOptions,
      associated,
      isClassification,
      isBillable,
      billable
    } = this.props;
    let updateBillable = isBillable != null ? isBillable === 1 : null;
    let itemBillable = billable != null ? billable === 1 : null;
    return (
      <div
        className={styles.labels_form}
        style={{ height: associated ? "267px" : "140px" }}
        onClick={event => {
          event.stopPropagation();
        }}
      >
        <table>
          <tr>
            <td width={"15%"}>
              <img src={"/img/icons/fr_flag.svg"} alt={""} />
            </td>
            <td>
              <input
                type={"text"}
                placeholder={_("frenchTitle")}
                value={labels.fr}
                onChange={e => this.props.onChangeLabelFormFr(e)}
                required={true}
              />
              <img src={"/img/icons/pencil.svg"} alt={""} />
            </td>
          </tr>
          <tr>
            <td>
              <img src={"/img/icons/en_flag.svg"} alt={""} />
            </td>
            <td>
              <input
                type={"text"}
                placeholder={_("englishTitle")}
                value={labels.en}
                onChange={e => this.props.onChangeLabelFormEn(e)}
                required={true}
              />
              <img src={"/img/icons/pencil.svg"} alt={""} />
            </td>
          </tr>
          <tr>
            <td>
              <img src={"/img/icons/nl_flag.svg"} alt={""} />
            </td>
            <td>
              <input
                type={"text"}
                placeholder={_("dutchTitle")}
                value={labels.nl}
                onChange={e => this.props.onChangeLabelFormNl(e)}
                required={true}
              />
              <img src={"/img/icons/pencil.svg"} alt={""} />
            </td>
          </tr>
          {associated ? (
            <tr className={styles.associatedSuperCategories}>
              <td>
                <span className={styles.label_span}>{_("AssociatedWith")}</span>
              </td>
              <td style={{ textAlign: "left" }}>
                <div className={styles.td}>
                  <Select
                    value={
                      this.props.selectedSuperCategory &&
                      superCategoriesOptions.find(
                        obj => obj.value === this.props.selectedSuperCategory
                      )
                    }
                    onChange={this.props.onChangeSelectedSuperCategory}
                    options={superCategoriesOptions}
                    className={classnames("select_small", "created")}
                    classNamePrefix="ttp-select"
                    isClearable={true}
                    placeholder={_("SuperCategory")}
                    menuPlacement="auto"
                  />
                </div>
              </td>
            </tr>
          ) : (
            ""
          )}
          {associated ? (
            <tr className={styles.associatedSuperCategories}>
              <td>
                <span className={styles.label_span}>{_("BelongsTo")}</span>
              </td>
              <td style={{ textAlign: "left" }}>
                <div className={styles.td}>
                  <Select
                    value={
                      this.props.selectedAnalysisPlan &&
                      analysisPlanOptions.find(
                        obj => obj.value === this.props.selectedAnalysisPlan
                      )
                    }
                    onChange={this.props.onChangeSelectedAnalysisPlan}
                    options={analysisPlanOptions}
                    className={classnames("select_small", "created")}
                    classNamePrefix="ttp-select"
                    isClearable={true}
                    placeholder={_("AnalysisPlan")}
                    menuPlacement="auto"
                  />
                </div>
              </td>
            </tr>
          ) : (
            ""
          )}
          {associated ? (
            <tr className={styles.associatedSuperCategories}>
              <td>
                <span className={styles.label_span}> {_("classified")}</span>
              </td>
              <td style={{ textAlign: "left" }}>
                <div className={styles.td}>
                  <Select
                    value={
                      this.props.selectedValuation &&
                      valuationOptions.find(
                        obj => obj.value === this.props.selectedValuation
                      )
                    }
                    onChange={this.props.onChangeSelectedValuation}
                    options={valuationOptions}
                    className={classnames("select_small", "created")}
                    classNamePrefix="ttp-select"
                    isClearable={true}
                    placeholder={_("classification")}
                    menuPlacement="auto"
                  />
                </div>
              </td>
            </tr>
          ) : (
            ""
          )}

          {isClassification === true ? (
            <tr>
              <td>
                <i className={classnames("icon icon-tag", styles.link_icon)} />
              </td>
              <td>
                <input
                  type={"text"}
                  placeholder={_("coefficient")}
                  value={labels.coefficient}
                  onChange={e => this.props.onChangeLabelFormCoefficient(e)}
                  required={true}
                />
                <img src={"/img/icons/pencil.svg"} alt={""} />
              </td>
            </tr>
          ) : (
            ""
          )}
          {associated && (
            <tr className={styles.associatedSuperCategories}>
              <td>
                <span className={styles.label_span}> {_("isBillable")}</span>
              </td>
              <td style={{ textAlign: "left" }}>
                <div className={styles.td}>
                  <span className={styles.billable_block}>
                    <Switch
                      checked={
                        updateBillable != null ? updateBillable : itemBillable
                      }
                      onChange={() => this.props.handleUpdateBillableState()}
                    />
                  </span>
                </div>
              </td>
            </tr>
          )}
        </table>
      </div>
    );
  }
}

export default LabelsForm;



// WEBPACK FOOTER //
// ./src/components/CategorySettings/LabelsForm.js